export default __webpack_public_path__ + "static/media/delivery-truck.c6e923b1.svg";